export default "__VITE_ASSET__1FVOy7$F__"